module.exports = __webpack_public_path__ + "share_pic_rule.png?f8ed9d7a4cbecd7a0911dc04d10cd500";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share_pic_rule.png
// module id = 351
// module chunks = 0